import SectorService from '../../services/Sector.js';
import BenefitService from '../../services/Benefit.js';
import DevelopmentStageService from '../../services/DevelopmentStage.js';
import GeographicalAreaService from '../../services/GeographicalArea.js';
import CountryService from '../../services/Country.js';
import PatentStatusService from '../../services/PatentStatus.js';
import CompanyTypeService from '../../services/CompanyTypes.js';
import InvestmentTypeService from '../../services/InvestmentTypes.js';
import CurrencyService from '../../services/Currencies.js';
import Multiselect from 'vue-multiselect';

if($('#innovations-advanced-search-and-filter').length){
    var app = new Vue({
        el: '#innovations-advanced-search-and-filter',
        data: {
            loading:false,
            sectors:[],
            sectorSlugs:[],
            additionalSectorIds:[],
            countries:[],
            countryIds:[],
            developmentStages:[],
            developmentStageIds:[],
            benefits:[],
            benefitIds:[],
            patentStatuses:[],
            patentStatusIds:[],
            geographicalAreas:[],
            geographicalAreaIds:[],
            companyTypes:[],
            companyTypeIds:[],
            investmentTypes:[],
            investmentTypeIds:[],
            currencies:[],
            currencyIds:[],
            showAdditionalFilters:false,
            searchOptions:{
                sector:null,
                search:'',
                countries:[],
                geographicalAreas:[],
                developmentStages:[],
                benefits:[],
                patentStatuses:[],
                investmentTypes:[],
                companyTypes:[],
                currencies:[],
                additionalSectors:[]
            }
        },
        methods: {
            getParameter(name, url = window.location.href){
                name = name.replace(/[\[\]]/g, '\\$&');
                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return '';
                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            },
            getSectorName(option){
                let value = this.sectors.filter(obj => {
                    return obj.slug === option
                });
                return value[0].name;
            },
            getCountryName(option){
                let value = this.countries.filter(obj => {
                    return obj.id === option
                });
                return value[0].name;
            },
            getGeographicalAreaName(option){
                let value = this.geographicalAreas.filter(obj => {
                    return obj.id === option
                });
                return value[0].name;
            },
            getDevelopmentStageName(option){
                let value = this.developmentStages.filter(obj => {
                    return obj.id === option
                });
                return value[0].name;
            },
            getBenefitName(option){
                let value = this.benefits.filter(obj => {
                    return obj.id === option
                });
                return value[0].name;
            },
            getPatentStatusName(option){
                let value = this.patentStatuses.filter(obj => {
                    return obj.id === option
                });
                return value[0].name;
            },
            getInvestmentTypeName(option){
                let value = this.investmentTypes.filter(obj => {
                    return obj.id === option
                });
                return value[0].name;
            },
            getCompanyTypeName(option){
                let value = this.companyTypes.filter(obj => {
                    return obj.id === option
                });
                return value[0].name;
            },
            getCurrencyName(option){
                let value = this.currencies.filter(obj => {
                    return obj.id === option
                });
                return value[0].name;
            },
            getAdditionalSectorName(option){
                let value = this.sectors.filter(obj => {
                    return obj.id === option
                });
                return value[0].name;
            },
            debounceInput: _.debounce(function () {
                this.processSearch();
            }, 1000),
            processSearch(){
                let url = '/innovations';

                if(this.searchOptions.sector){
                    url = url+'/'+this.searchOptions.sector;
                }

                if(this.searchOptions.search){
                    url = url+'?search='+this.searchOptions.search;
                }else{
                    url = url+'?search=';
                }

                if(this.searchOptions.countries && this.searchOptions.countries.length){
                    url = url+'&countries='+encodeURIComponent(JSON.stringify(this.searchOptions.countries));
                }

                if(this.searchOptions.geographicalAreas && this.searchOptions.geographicalAreas.length){
                    url = url+'&geographicalAreas='+encodeURIComponent(JSON.stringify(this.searchOptions.geographicalAreas));
                }

                if(this.searchOptions.benefits && this.searchOptions.benefits.length){
                    url = url+'&benefits='+encodeURIComponent(JSON.stringify(this.searchOptions.benefits));
                }

                if(this.searchOptions.developmentStages && this.searchOptions.developmentStages.length){
                    url = url+'&developmentStages='+encodeURIComponent(JSON.stringify(this.searchOptions.developmentStages));
                }

                if(this.searchOptions.patentStatuses && this.searchOptions.patentStatuses.length){
                    url = url+'&patentStatuses='+encodeURIComponent(JSON.stringify(this.searchOptions.patentStatuses));
                }

                if(this.searchOptions.companyTypes && this.searchOptions.companyTypes.length){
                    url = url+'&companyTypes='+encodeURIComponent(JSON.stringify(this.searchOptions.companyTypes));
                }

                if(this.searchOptions.investmentTypes && this.searchOptions.investmentTypes.length){
                    url = url+'&investmentTypes='+encodeURIComponent(JSON.stringify(this.searchOptions.investmentTypes));
                }

                if(this.searchOptions.currencies && this.searchOptions.currencies.length){
                    url = url+'&currencies='+encodeURIComponent(JSON.stringify(this.searchOptions.currencies));
                }

                if(this.searchOptions.additionalSectors && this.searchOptions.additionalSectors.length){
                    url = url+'&additionalSectors='+encodeURIComponent(JSON.stringify(this.searchOptions.additionalSectors));
                }

                window.location.href = url;
            },
            checkForCurrentSearch(){
                if(
                    (this.searchOptions.currencies &&this.searchOptions.currencies.length > 0) || 
                    (this.searchOptions.investmentTypes && this.searchOptions.investmentTypes.length > 0) || 
                    (this.searchOptions.companyTypes && this.searchOptions.companyTypes.length > 0) || 
                    (this.searchOptions.geographicalAreas && this.searchOptions.geographicalAreas.length > 0) ||
                    (this.searchOptions.patentStatuses && this.searchOptions.patentStatuses.length > 0) || 
                    (this.searchOptions.developmentStages && this.searchOptions.developmentStages.length > 0) || 
                    (this.searchOptions.countries && this.searchOptions.countries.length > 0) || 
                    (this.searchOptions.benefits && this.searchOptions.benefits.length > 0)
                ){
                    this.showAdditionalFilters = true;
                    $('html, body').animate({ scrollTop: $('#innovations-advanced-search-and-filter').offset().top-100 }, 0);
                }
            }
        },
        mounted () {
            this.searchOptions.search = this.getParameter('search');

            BenefitService.getBenefits().then(data => {
                this.benefits = data;
                this.benefitIds = this.benefits.map(a => a.id);
                this.searchOptions.benefits = JSON.parse(decodeURIComponent(this.getParameter('benefits')));
                this.checkForCurrentSearch();
            });
            CountryService.getCountries().then(data => {
                this.countries = data;
                this.countryIds = this.countries.map(a => a.id);
                this.searchOptions.countries = JSON.parse(decodeURIComponent(this.getParameter('countries')));
                this.checkForCurrentSearch();
            });
            DevelopmentStageService.getDevelopmentStages().then(data => {
                this.developmentStages = data;
                this.developmentStageIds = this.developmentStages.map(a => a.id);
                this.searchOptions.developmentStages = JSON.parse(decodeURIComponent(this.getParameter('developmentStages')));
                this.checkForCurrentSearch();
            });
            PatentStatusService.getPatentStatuses().then(data => {
                this.patentStatuses = data;
                this.patentStatusIds = this.patentStatuses.map(a => a.id);
                this.searchOptions.patentStatuses = JSON.parse(decodeURIComponent(this.getParameter('patentStatuses')));
                this.checkForCurrentSearch();
            });
            GeographicalAreaService.getGeographicalAreas().then(data => {
                this.geographicalAreas = data;
                this.geographicalAreaIds = this.geographicalAreas.map(a => a.id);
                this.searchOptions.geographicalAreas = JSON.parse(decodeURIComponent(this.getParameter('geographicalAreas')));
                this.checkForCurrentSearch();
            });
            CompanyTypeService.getCompanyTypes().then(data => {
                this.companyTypes = data;
                this.companyTypeIds = this.companyTypes.map(a => a.id);
                this.searchOptions.companyTypes = JSON.parse(decodeURIComponent(this.getParameter('companyTypes')));
                this.checkForCurrentSearch();
            });
            InvestmentTypeService.getInvestmentTypes().then(data => {
                this.investmentTypes = data;
                this.investmentTypeIds = this.investmentTypes.map(a => a.id);
                this.searchOptions.investmentTypes = JSON.parse(decodeURIComponent(this.getParameter('investmentTypes')));
                this.checkForCurrentSearch();
            });
            CurrencyService.getCurrencies().then(data => {
                this.currencies = data;
                this.currencyIds = this.currencies.map(a => a.id);
                this.searchOptions.currencies = JSON.parse(decodeURIComponent(this.getParameter('currencies')));
                this.checkForCurrentSearch();
            });
            SectorService.getSectors().then(data => {
                this.sectors = data;
                this.sectorSlugs = this.sectors.map(a => a.slug);
                this.additionalSectorIds = this.sectors.map(a => a.id);
                this.searchOptions.additionalSectors = JSON.parse(decodeURIComponent(this.getParameter('additionalSectors')));
                this.searchOptions.sector = sector;
                this.loading = false;
                this.checkForCurrentSearch();
            });
        },
        components: {
            'multiselect': Multiselect,
        },
    });
}